import React, { useCallback } from 'react';
import { PaymentSource } from '../../../constants';
import { reportError } from '../../../lib/reportError';
import { useErrorModal } from '../../../hooks/useErrorModal';
import { useCheckout } from '../../../hooks/useCheckout';
import {
  useCart,
  useUpdateCartMutation,
  CartUpdateAction,
  CartUpdatePropertyName
} from '../../../hooks/useCart';
import { CheckoutSection } from '../../CheckoutSection';
import { AmazonShippingAndPayment } from '../AmazonShippingAndPayment';

export const CheckoutAmazonShippingAndPayment: React.FC = () => {
  const { showErrorModal } = useErrorModal();
  const { isShippingAddressSelected, isPaymentMethodSelected } = useCheckout();
  const {
    cart: {
      attributes: { addressId }
    }
  } = useCart();
  const [updateCart] = useUpdateCartMutation();

  const onSwitchToAdyen = useCallback(async () => {
    try {
      await updateCart(CartUpdateAction.PaymentSource, {
        [CartUpdatePropertyName.PaymentSource]: PaymentSource.Adyen
      });
    } catch (error) {
      reportError(error);
      showErrorModal();
    }
  }, [showErrorModal, updateCart]);

  return (
    <CheckoutSection title="Shipping &amp; Payment">
      <AmazonShippingAndPayment
        addressId={addressId}
        isFilled={isShippingAddressSelected && isPaymentMethodSelected}
        onSwitchToAdyen={onSwitchToAdyen}
      />
    </CheckoutSection>
  );
};
